module.exports = __webpack_public_path__ + "static/media/RationalDisplay-Light.18295333.otf";